const MAX_RECENTS = 6;

function storageKey(variant) {
  return `vendalist_search_recent_${variant === 'vendor' ? 'vendor' : 'admin'}`;
}

export function readSearchRecents(variant) {
  try {
    const raw = localStorage.getItem(storageKey(variant));
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.slice(0, MAX_RECENTS) : [];
  } catch {
    return [];
  }
}

export function pushSearchRecent(variant, item) {
  if (!item?.href || !item?.label) return readSearchRecents(variant);
  try {
    const nextItem = {
      id: item.id || item.href,
      type: item.type || 'page',
      label: item.label,
      meta: item.meta || 'Recent',
      href: item.href,
    };
    const prev = readSearchRecents(variant).filter(
      (entry) => entry.href !== nextItem.href
    );
    const next = [nextItem, ...prev].slice(0, MAX_RECENTS);
    localStorage.setItem(storageKey(variant), JSON.stringify(next));
    return next;
  } catch {
    return readSearchRecents(variant);
  }
}
